import React from "react";

function Chest() {
  return (
    <div className="gif-background">
      <img
        className="chest"
        alt="Chest GIF"
        src="./ocean/chest.png"
        style={{ top: "82.5vh", left: "76.5vw" }}
      />
    </div>
  );
}

export default Chest;
